
import React, { useContext } from "react";
import { AuthContext } from "../../../Contexts/AuthContext";
import AdminAnimalList from "../../admin/adminAnimalList/adminAnimalList";

export default function AnimalsList() {
  const { user } = useContext(AuthContext);
  if (!user) return null;
  if (user.role === 'admin') {
    return <AdminAnimalList />;
  }
  if (user.role === 'eleveur') {
    return <AdminAnimalList userId={user.id} />;
  }
  return null;
}
